import { defineMessages } from 'react-intl';

import { color } from 'app/shared/styles_js/variables';

import { LEADS_BENCHMARK_LEAD_TYPES } from '../../../redux/leads/constants';

export const intlLeadsBenchmarkTableLabels = defineMessages({
  [LEADS_BENCHMARK_LEAD_TYPES.TOTAL]: {
    id: 'dealer.leadsBenchmark.table.tableRowLabels.total',
    defaultMessage: 'Gesamt',
    styles: { fontWeight: 'bold', color: color.brandSecondary },
  },
  [LEADS_BENCHMARK_LEAD_TYPES.PHONE]: {
    id: 'dealer.leadsBenchmark.table.tableRowLabels.phoneLeads',
    defaultMessage: 'Telefon-Leads',
  },
  [LEADS_BENCHMARK_LEAD_TYPES.EMAIL]: {
    id: 'dealer.leadsBenchmark.table.tableRowLabels.emailLeads',
    defaultMessage: 'E-Mail-Leads',
  },
  [LEADS_BENCHMARK_LEAD_TYPES.CHAT]: {
    id: 'dealer.leadsBenchmark.table.tableRowLabels.chatLeads',
    defaultMessage: 'Chat-Leads',
  },
});

export const intlLeadsBenchmarkTableRowFinancialInterestLabels = defineMessages(
  {
    [LEADS_BENCHMARK_LEAD_TYPES.TOTAL]: {
      id: 'dealer.leadsBenchmark.table.tableRowLabels.financialInterest',
      defaultMessage: 'mit Finanzierungsinteresse',
    },
    [LEADS_BENCHMARK_LEAD_TYPES.PHONE]: {
      id: 'dealer.leadsBenchmark.table.tableRowLabels.financialInterest',
      defaultMessage: 'mit Finanzierungsinteresse',
    },
    [LEADS_BENCHMARK_LEAD_TYPES.EMAIL]: {
      id: 'dealer.leadsBenchmark.table.tableRowLabels.financialInterest',
      defaultMessage: 'mit Finanzierungsinteresse',
    },
    [LEADS_BENCHMARK_LEAD_TYPES.CHAT]: {
      id: 'dealer.leadsBenchmark.table.tableRowLabels.financialInterest',
      defaultMessage: 'mit Finanzierungsinteresse',
    },
  },
);
